/**
 * Video'nun **gerçek** en-boy oranı.
 *
 * Neden sabit `16 / 9` yetmiyor?
 *
 * CSS'te `.watch__video` 16:9 varsayılıyordu. Kaynak 4:3, anamorfik veya
 * dikey bir video ise video bu 16:9 kutunun içine `contain` ile sığdırılıyor
 * ve yanlarda/üstte gereksiz siyah alan oluşuyordu. `videoWidth/videoHeight`
 * metadata ile geldiği için kutu oranını **kaynağa göre** güncelliyoruz.
 */
import { useEffect, useState } from 'react';

export interface VideoAspect {
  /** Genişlik / yükseklik. */
  ratio: number;
  /** CSS `aspect-ratio` değeri (`1920 / 1080`). */
  css: string;
}

export function useVideoAspect(video: HTMLVideoElement | null): VideoAspect | null {
  const [aspect, setAspect] = useState<VideoAspect | null>(null);

  useEffect(() => {
    if (video === null) {
      setAspect(null);
      return;
    }

    const update = (): void => {
      const width = video.videoWidth;
      const height = video.videoHeight;
      if (width > 0 && height > 0) {
        setAspect({ ratio: width / height, css: `${width} / ${height}` });
      }
    };

    const reset = (): void => setAspect(null);

    update();
    video.addEventListener('loadedmetadata', update);
    video.addEventListener('resize', update);
    video.addEventListener('emptied', reset);
    return () => {
      video.removeEventListener('loadedmetadata', update);
      video.removeEventListener('resize', update);
      video.removeEventListener('emptied', reset);
    };
  }, [video]);

  return aspect;
}
